var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { ThemePalette, ThemeShadowSizes } from "../../../../theme/_Types";
import { Container } from "../../03-base/Container";
import { Div } from "../../03-base/Div";
import { Menu, MenuOrientation } from "../../07-organisms/Menu";
/**
 *
 */
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    /**
     *
     * @param props
     */
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { showContent: false, currentTab: _this.props.defaultTab };
        _this.showTabContent = _this.showTabContent.bind(_this);
        return _this;
    }
    Tabs.prototype.componentDidMount = function () {
        this.showTabContent(this.props.defaultTab);
    };
    Tabs.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            !this.props.child &&
                React.createElement(Div, { theme: {
                        padding: {
                            "": { b: 3 },
                            "sm": { b: 4 },
                        },
                    } },
                    React.createElement(Menu, { orientation: MenuOrientation.HORIZONTAL, items: this.getItems(this.props.tabs) })),
            React.createElement(Div, { theme: {
                    padding: {
                        "": { b: 3 },
                        "sm": { b: 4 },
                    },
                } },
                React.createElement(React.Fragment, null,
                    this.props.child &&
                        React.createElement(Div, { theme: { shadow: ThemeShadowSizes.TINY } },
                            React.createElement(Container, { theme: {
                                    palette: ThemePalette.CONTRAST_TERTIARY,
                                    padding: {
                                        "": { t: 1 },
                                        "sm": { t: 2 },
                                    },
                                } },
                                React.createElement(Menu, { orientation: MenuOrientation.HORIZONTAL, items: this.getItems(this.props.tabs) }))),
                    this.state.showContent && (React.createElement(this.state.currentTab.component, __assign({}, this.props.params)))))));
    };
    Tabs.prototype.getItems = function (tabs) {
        var _this = this;
        return tabs
            .map(function (tab) { return ({
            disabled: !tab.component,
            children: tab.title,
            link: { onClick: function () { return _this.showTabContent(tab); } },
            active: _this.state.currentTab.key === tab.key,
        }); });
    };
    Tabs.prototype.showTabContent = function (tab) {
        this.setState({
            showContent: true,
            currentTab: tab,
        });
    };
    return Tabs;
}(React.Component));
export { Tabs };
